import type {EncounterPaywallProperties} from '@gaia/ampli';
import {atom, useAtom, useAtomValue, useSetAtom} from 'jotai';

import type {UpsellFeatureCardProps} from './UpsellFeatureCard';

type UpsellModalState =
    | {
          selectedScreen: UpsellFeatureCardProps['key'];
          analyticsProperties: EncounterPaywallProperties;
      }
    | {selectedScreen: undefined};

const upsellModalAtom = atom<UpsellModalState | undefined>(undefined);

export function useUpsellModalState(): UpsellModalState | undefined {
    return useAtomValue(upsellModalAtom);
}

export function useSetUpsellModalState() {
    return useSetAtom(upsellModalAtom);
}

export function useUpsellModal() {
    return useAtom(upsellModalAtom);
}
